/*!

=========================================================
* Black Dashboard React v1.2.2 — Painel Toca da Onça
=========================================================

* Base: Creative Tim (MIT). Dados reais do CRM da Toca da Onça Modas.

=========================================================

*/
import React from "react";
import classNames from "classnames";
import { Line, Bar } from "react-chartjs-2";

import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";

import {
  chartExample1,
  chartExample2,
  chartExample3,
  chartExample4,
} from "variables/charts.js";
import { supabase } from "supabaseClient";

const STATS_PADRAO = {
  totalClientes: 7542,
  quente: 53,
  morno: 58,
  frio: 55,
  naoSegmentados: 7376,
  caixaHoje: 834,
  lucroLiquido: 350.28,
  vendas: [
    { nome: "Kit 12 Relógios", custo: 200, venda: 400, lucro: 168.0 },
    { nome: "Calça Jeans Skinny", custo: 40, venda: 80, lucro: 33.6 },
    { nome: "Vestido Longo Luxo", custo: 30, venda: 60, lucro: 25.2 },
    { nome: "Conjunto Fitness", custo: 28, venda: 55, lucro: 22.6 },
    { nome: "Blusa Pedraria", custo: 25, venda: 50, lucro: 21.0 },
    { nome: "Camisola Renda", custo: 22, venda: 45, lucro: 19.4 },
  ],
  atualizadoEm: null,
};

const brl = (v) =>
  "R$ " +
  Number(v || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const num = (v) => Number(v || 0).toLocaleString("pt-BR");

function Dashboard(props) {
  const [bigChartData, setbigChartData] = React.useState("data1");
  const [stats, setStats] = React.useState(STATS_PADRAO);
  const setBgChartData = (name) => {
    setbigChartData(name);
  };
  React.useEffect(() => {
    const carregar = () =>
      fetch("/stats.json", { cache: "no-store" })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          if (d && d.totalClientes) setStats({ ...STATS_PADRAO, ...d });
        })
        .catch(() => {});
    carregar();
    const t = setInterval(carregar, 60000);
    return () => clearInterval(t);
  }, []);

  const [catalogo, setCatalogo] = React.useState(null);
  React.useEffect(() => {
    (async () => {
      try {
        const { data } = await supabase
          .from("products")
          .select("price,stock,category")
          .eq("status", "active")
          .limit(2000);
        if (!data) return;
        const cats = {};
        let valor = 0, soma = 0;
        data.forEach((p) => {
          const c = p.category || "—";
          cats[c] = (cats[c] || 0) + 1;
          valor += (Number(p.price) || 0) * (Number(p.stock) || 0);
          soma += Number(p.price) || 0;
        });
        const top = Object.entries(cats).sort((a, b) => b[1] - a[1]).slice(0, 6);
        setCatalogo({ total: data.length, valor, medio: soma / data.length, top });
      } catch (e) {}
    })();
  }, []);

  const vendas = stats.vendas || STATS_PADRAO.vendas;
  return (
    <>
      <div className="content">
        <Row>
          <Col xs="12">
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col className="text-left" sm="6">
                    <h5 className="card-category">Base de clientes</h5>
                    <CardTitle tag="h2">Crescimento</CardTitle>
                  </Col>
                  <Col sm="6">
                    <ButtonGroup
                      className="btn-group-toggle float-right"
                      data-toggle="buttons"
                    >
                      <Button
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data1",
                        })}
                        color="info"
                        id="0"
                        size="sm"
                        onClick={() => setBgChartData("data1")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Clientes
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="1"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data2",
                        })}
                        onClick={() => setBgChartData("data2")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Vendas
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-money-coins" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="2"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data3",
                        })}
                        onClick={() => setBgChartData("data3")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Leads
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-chat-33" />
                        </span>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={chartExample1[bigChartData]}
                    options={chartExample1.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col lg="4">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Clientes na base</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-single-02 text-info" /> {num(stats.totalClientes)}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={chartExample2.data}
                    options={chartExample2.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Caixa hoje</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-money-coins text-success" /> {brl(stats.caixaHoje)}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Bar
                    data={chartExample3.data}
                    options={chartExample3.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Lucro líquido hoje</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-chart-bar-32 text-primary" /> {brl(stats.lucroLiquido)}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={chartExample4.data}
                    options={chartExample4.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {catalogo && (
          <Row>
            <Col xs="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">
                    <i className="tim-icons icon-bag-16 text-info" /> Catálogo do site — ao vivo
                  </CardTitle>
                  <p className="card-category">Direto do banco do tocadaoncamodas.com.br</p>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col lg="3" md="6">
                      <p className="card-category text-muted">Produtos ativos</p>
                      <CardTitle tag="h3" className="text-info">{num(catalogo.total)}</CardTitle>
                    </Col>
                    <Col lg="3" md="6">
                      <p className="card-category text-muted">Valor em estoque</p>
                      <CardTitle tag="h3" className="text-success">{brl(catalogo.valor)}</CardTitle>
                    </Col>
                    <Col lg="3" md="6">
                      <p className="card-category text-muted">Preço médio</p>
                      <CardTitle tag="h3" className="text-warning">{brl(catalogo.medio)}</CardTitle>
                    </Col>
                    <Col lg="3" md="6">
                      <p className="card-category text-muted">Categorias</p>
                      <CardTitle tag="h3" className="text-white">{catalogo.top.length}+</CardTitle>
                    </Col>
                  </Row>
                  <div style={{ marginTop: 10 }}>
                    {catalogo.top.map(([c, n]) => (
                      <span key={c} style={{ display: "inline-block", background: "rgba(29,140,248,.12)", color: "#1d8cf8", borderRadius: 20, padding: "4px 14px", margin: "4px 6px 0 0", fontSize: 13 }}>
                        {c} · {n}
                      </span>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        <Row>
          <Col lg="5" md="12">
            <Card className="card-tasks">
              <CardHeader>
                <h6 className="title d-inline">Leads por temperatura</h6>
                <p className="card-category d-inline"> segmentação atual</p>
              </CardHeader>
              <CardBody>
                <div className="table-full-width table-responsive">
                  <Table>
                    <tbody>
                      <tr>
                        <td>
                          <i className="tim-icons icon-sound-wave text-danger" />
                        </td>
                        <td>
                          <p className="title">Leads quentes</p>
                          <p className="text-muted">Prontos pra fechar — vendedor humano</p>
                        </td>
                        <td className="text-right">
                          <span className="text-danger" style={{ fontSize: "22px", fontWeight: 600 }}>{num(stats.quente)}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <i className="tim-icons icon-sound-wave text-warning" />
                        </td>
                        <td>
                          <p className="title">Leads mornos</p>
                          <p className="text-muted">Interessados — remarketing e proposta</p>
                        </td>
                        <td className="text-right">
                          <span className="text-warning" style={{ fontSize: "22px", fontWeight: 600 }}>{num(stats.morno)}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <i className="tim-icons icon-sound-wave text-info" />
                        </td>
                        <td>
                          <p className="title">Leads frios</p>
                          <p className="text-muted">Nutrição automática pra esquentar</p>
                        </td>
                        <td className="text-right">
                          <span className="text-info" style={{ fontSize: "22px", fontWeight: 600 }}>{num(stats.frio)}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <i className="tim-icons icon-refresh-02 text-muted" />
                        </td>
                        <td>
                          <p className="title">Ainda não segmentados</p>
                          <p className="text-muted">Fila pra classificação automática</p>
                        </td>
                        <td className="text-right">
                          <span className="text-muted" style={{ fontSize: "22px", fontWeight: 600 }}>{num(stats.naoSegmentados)}</span>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="7" md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Últimas vendas — lucro real por peça</CardTitle>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Produto</th>
                      <th className="text-center">Custo</th>
                      <th className="text-center">Venda</th>
                      <th className="text-center">Lucro líquido</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendas.map((v, i) => (
                      <tr key={i}>
                        <td>{v.nome}</td>
                        <td className="text-center">{brl(v.custo)}</td>
                        <td className="text-center">{brl(v.venda)}</td>
                        <td className="text-center text-success" style={{ fontWeight: 600 }}>
                          {brl(v.lucro)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Dashboard;
